import { Button, ButtonProps } from "@mui/material";
/**
CustomButton
یک کامپوننت دکمه سفارشی که بر پایه دکمه MUI ساخته شده است.
دارای استایل پیش‌فرض شامل رنگ متن سفید، گوشه‌های گرد، وزن فونت متوسط و تغییر رنگ پس‌زمینه هنگام هاور.
دکمه هنگام غیرفعال بودن رنگ خاکستری می‌گیرد و نشانگر موس نیز به شکل مناسب تغییر می‌کند.
@param {object} props - تمام ویژگی‌های استاندارد ButtonProps از MUI
@param {React.ReactNode} props.children - محتوای درون دکمه
@param {boolean} [props.disabled] - وضعیت غیرفعال بودن دکمه
@param {object} [props.sx] - استایل سفارشی برای دکمه
@returns JSX.Element
*/
const CustomButton = ({ children, disabled, sx, ...props }: ButtonProps) => {
  return (
    <Button
      {...props}
      disabled={disabled}
      sx={{
        color: "white.main",
        textTransform: "none",
        fontWeight: 500,
        borderRadius: "9px",
        cursor: disabled ? "not-allowed" : "pointer",
        backgroundColor: disabled
          ? "transparent !important"
          : "#89C6CE !important",
        "&:hover": { backgroundColor: disabled ? "gray" : "primary.dark" },

        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
